import { render, staticRenderFns } from "./VentaConRecinto.vue?vue&type=template&id=0c1c5af0"
import script from "./VentaConRecinto.vue?vue&type=script&lang=js"
export * from "./VentaConRecinto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports